export function ChatItem({ data, onClick, activeChat }) {
  return (
    <div className="d-flex align-items-center justify-content-between mb-5">
      <div className="d-flex align-items-center gap-1">
        <div className="btn btn-clean btn-icon btn-md mr-1" onClick={onClick}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29.702"
            height="23.012"
            viewBox="0 0 29.702 23.012"
          >
            <path
              id="Icon_simple-minutemailer"
              data-name="Icon simple-minutemailer"
              d="M6.886,4.055l4.27,4.621L8.143,14.614l6.361-1.14,2.9,6.987L29.7,4.33ZM6.1,14.064l1.184-.974-1.527.483L5.6,13.35l.631-.613-.828.334A8.43,8.43,0,0,0,2.64,27.066a8.37,8.37,0,0,1-1.1-4.152,8.64,8.64,0,0,1,5.34-7.945l.39-.948-.928.41-.261-.353Zm5.4-2.438,1.978-3.491L25.108,5.411,11.5,11.626Z"
              transform="translate(0 -4.055)"
            />
          </svg>
        </div>
        <div className="d-flex flex-column">
          <span
            className={`text-hover-primary font-weight-bold font-size-lg cursor-pointer${
              activeChat.ticket_id === data.ticket_id ? " text-primary" : ""
            }`}
            onClick={onClick}
          >
            {data.title}
          </span>
          <span className="text-muted font-weight-bold font-size-sm">
            {data.sent_time}
          </span>
        </div>
      </div>
      {data.unread_ticket && (
        <div className="d-flex flex-column align-items-end">
          <span className="label label-sm label-sm-10 label-success"></span>
        </div>
      )}
    </div>
  );
}

export function ChatItemLoading() {
  return (
    <div className="d-flex align-items-center justify-content-between mb-5">
      <div className="d-flex align-items-center gap-1 full-width">
        <div className="loading-icon" style={{ width: "45px", height: "40px", borderRadius: "4px" }}>
          <span className="loading-icon full-width full-height">{" "}</span>
        </div>
        <div className="d-flex flex-column full-width">
          <span className="text-hover-primary font-weight-bold font-size-lg loading-row w-25">{" "}</span>
          <span className="text-muted font-weight-bold font-size-sm loading-row w-50 mt-2">{" "}</span>
        </div>
      </div>
    </div>
  );
}
